
<div :class="['chips', { profile }]">
  <dropdown
    v-if="card.variation"
    :active="otherVariationsMenuOpen"
    :disabled="!showOtherVariations"
    :overflow-hidden="!profile"
    @close="otherVariationsMenuOpen = false"
  >
    <grade-variation-chip
      :as="showOtherVariations ? 'button' : 'span'"
      :dropdown="showOtherVariations"
      :variation="card.variation"
      :profile="profile"
      @click.native="otherVariationsMenuOpen = showOtherVariations && !otherVariationsMenuOpen"
    />

    <template #menu>
      <dropdown-menu
        :options="otherVariationOptions"
        :max-height="200"
        @select="switchCard"
      />
    </template>
  </dropdown>

  <template v-if="card.grader && card.grade && !card.cardId">
    <grade-variation-chip
      :grade="gradeDisplay(card.grader, card.grade)"
    />

    <grade-variation-chip
      v-if="card.autographGrade"
      :grade="autographGradeDisplay(card.autographGrade)"
      no-color
    />
  </template>

  <template v-else>
    <dropdown
      :active="otherGradesMenuOpen"
      :disabled="!showOtherGrades"
      :overflow-hidden="!profile"
      @close="otherGradesMenuOpen = false"
    >
      <grade-variation-chip
        :as="showOtherGrades ? 'button' : 'span'"
        :grade="card.condition"
        :dropdown="showOtherGrades"
        @click.native="otherGradesMenuOpen = showOtherGrades && !otherGradesMenuOpen"
      />

      <template #menu>
        <dropdown-menu
          :options="otherGradeOptions"
          :max-height="200"
          @select="switchCard"
        />
      </template>
    </dropdown>
  </template>

  <grade-variation-chip
    v-if="card.qualifierType"
    :grade="card.qualifierType"
    no-color
  />

  <icon
    class="key-card-icon"
    v-if="card.keyCard"
    name="stars"
    v-tooltip="{ content: `This card has been selected as the Key Card and representation of the general market trend for ${card.player}.`, delay: { show: 1000, hide: 100 }, placement: 'bottom' }"
  />

  <slot />
</div>
